import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import 'font-awesome/css/font-awesome.min.css';
import Root from './root';
import { Provider } from "react-redux";
import configureStore from "./store/ConfigureStore";
import * as Sentry from "@sentry/react";
import { Experiment, Variant } from 'react-google-optimize';
import ReactPixel from 'react-facebook-pixel';
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";

// ReactGA.initialize("G-20G0JHESG4");
// ReactGA.initialize('UA-2638006-46');
// ReactGA.initialize('UA-2638006-57');
// ReactGA.pageview(window.location.pathname + window.location.search);
// ReactPixel.init('359778478146451');

const store = configureStore();
const RAW_SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV;

// The default .env (used by a plain `npm start`, i.e. a developer's own
// machine) and .env.dev (the actual deployed Dev server) both set
// REACT_APP_SENTRY_ENV="DEV" - so the Sentry "environment" tag alone can't
// tell a local run apart from the real Dev deployment, even though the page
// URL already does (localhost:3000 vs directorydv.scouting.org, captured
// automatically by the Sentry SDK from window.location.href). Tag local
// runs as "LOCAL" instead, so they're distinguishable without having to
// inspect the URL on every event. Every other environment is unaffected.
const isLocalhost = typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
const SENTRY_ENV = isLocalhost ? 'LOCAL' : RAW_SENTRY_ENV;

Sentry.init({
    dsn: "https://a450ba4a08cc4479859fb807f0d766f5@sentry.io/1796608",
    environment: SENTRY_ENV,
    beforeBreadcrumb: () => null,
});

// Kept on the raw (non-localhost-overridden) value so this PROD-only
// behavior doesn't shift based on the new LOCAL tag.
const Wrapper = (RAW_SENTRY_ENV === 'PROD') ? Sentry.ErrorBoundary : React.Fragment;
console.log("SENTRY_ENV:", SENTRY_ENV);

ReactDOM.render(
    <Provider store={store}>
        <Wrapper>
            <Experiment key='OPT-MX9H3JC'>
                <Root />
            </Experiment>
        </Wrapper>
    </Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js